module.exports = __webpack_public_path__ + "static/media/hdsd-report-guide.897dbe6b.jpg";